<template>
  <!--
    	作者：wangxw
    	时间：2019-10-26
    	描述：产品分类-添加
    -->
  <el-dialog title="查看在线服务时长" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-table size="small" :data="tableData" border style="width: 100%">
      <el-table-column prop="ymd" label="日期"></el-table-column>
      <el-table-column prop="minutes" label="时长/分钟"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column prop="update_time" label="更新时间"></el-table-column>
    </el-table>
    <!--分页-->
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </el-dialog>

</template>

<script>
import Technician from "@/api/technician.js";
export default {
  components: {},
  data() {
    return {
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,

      /*左边长度*/
      formLabelWidth: "120px",
      /*是否显示*/
      dialogVisible: false,
      loading: false,
      /*是否上传图片*/
      isupload: false,
      waiter_user_id: "",
      tableData: [],
      categoryModel: {},
      totalDataNumber: 0
    };
  },
  props: ["open_edit", "editform"],
  created() {
    this.dialogVisible = this.open_edit;
    this.waiter_user_id = this.editform.waiter_user_id;
    if (this.waiter_user_id) {
      this.getData();
    }
  },
  methods: {
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.loading = true;
      self.curPage = val;
      self.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.pageSize = val;
      this.getData();
    },

    /**/
    getData() {
      let self = this;
      let Params = {};
      Params.pageIndex = self.curPage;
      Params.waiter_user_id = self.waiter_user_id;
      Params.pageSize = self.pageSize;
      Technician.timeworkLog(Params)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
          console.log("===========", data.data.data);
          self.totalDataNumber = data.data.total;
          // self.dialogFormVisible(true);
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*关闭弹窗*/
    dialogFormVisible(e) {
      if (e) {
        this.$emit("closeDialog", {
          type: "success",
          openDialog: false
        });
      } else {
        this.$emit("closeDialog", {
          type: "error",
          openDialog: false
        });
      }
    }
  }
};
</script>

<style>
.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/technician/online/onlinedetail.vue